import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/util/page";
import { Restock } from "./restock";
import { RestockSearchResult } from "./restock-search-result";

@Injectable()
export class RestockService {
  constructor(private httpClient: HttpClient) { }

  public addReferenceToRestock(reference: string, quantity: number): Observable<void> {
    return this.httpClient.post<void>("/api/purchase/restock?isbn=" + reference + "&quantity=" + quantity, null);
  }

  public complete(restock: string): Observable<void> {
    return this.httpClient.put<void>("/api/purchase/restock/" + restock + "?complete", null);
  }

  public findById(restock: string): Observable<Restock> {
    return this.httpClient.get<Restock>("/api/purchase/restock/" + restock);
  }

  public removeDetail(restock: string, reference: string): Observable<void> {
    return this.httpClient.delete<void>("/api/purchase/restock/" + restock + "/" + reference);
  }

  public search(): Observable<Page<RestockSearchResult>> {
    return this.httpClient.get<Page<RestockSearchResult>>("/api/purchase/restock?sort=creationDate,DESC");
  }

  public updateQuantity(restock: string, reference: string, quantity: number): Observable<void> {
    return this.httpClient.put<void>("/api/purchase/restock/" + restock + "/" + reference + "?quantity=" + quantity, null);
  }
}